// src/utils/CryptoUtils.ts
export class CryptoUtils {
    // Convert ArrayBuffer to Base64 string
    static arrayBufferToBase64(buffer: ArrayBuffer): string {
      const bytes = new Uint8Array(buffer);
      let binary = '';
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    }
  
    // Convert Base64 string to ArrayBuffer
    static base64ToArrayBuffer(base64: string): ArrayBuffer {
      const binaryString = atob(base64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }
  
    // Convert PEM to ArrayBuffer for RSA key import
    static pemToArrayBuffer(pem: string): ArrayBuffer {
      const base64 = pem
        .replace('-----BEGIN PUBLIC KEY-----', '')
        .replace('-----END PUBLIC KEY-----', '')
        .replace(/\s+/g, '');
      
      return this.base64ToArrayBuffer(base64);
    }
  
    // Generate PEM format from base64 public key
    static base64ToPem(base64Key: string): string {
      const pem = `-----BEGIN PUBLIC KEY-----\n${base64Key.match(/.{1,64}/g)?.join('\n')}\n-----END PUBLIC KEY-----`;
      return pem;
    }
  
    // Implement PKCS#7 unpadding
    static unpadData(data: Uint8Array): Uint8Array {
      const padLength = data[data.length - 1];
      return data.slice(0, data.length - padLength);
    }
  
    // Decrypt data using AES-CBC
    static async decryptWithAES(key: CryptoKey, iv: ArrayBuffer, data: ArrayBuffer): Promise<Uint8Array> {
      return new Uint8Array(
        await window.crypto.subtle.decrypt(
          {
            name: 'AES-CBC',
            iv: iv
          },
          key,
          data
        )
      );
    }
  }